import React from "react";
import { Grid } from "@client/shared/components";
import { noop } from "@client/shared/constants";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { globalStyles } from "@client/shared/constants";
import style from "./style";

const UsersView = ({
  entries = [],
  entriesCount = 0,
  columnConfig = [],
  pageNumber = 1,
  pageSize = 5,
  order = null,
  orderBy = "",
  isLoading = false,
  handlePageNumberChange = noop,
  handlePageSizeChange = noop,
  handleSortChange = noop,
  handleGridReady = noop,
}) => {
  return (
    <>
      <Box
        sx={{
          p: 2,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            p: 3,
            ...style.pageTitleWrapper,
          }}
        >
          <Typography variant="h6">User Permissions</Typography>
          <Typography
            variant="body2"
            sx={{
              ...globalStyles.text.color.secondaryText,
            }}
          >
            Changes to individual user permissions will need to be made in
            Service Web.
          </Typography>
        </Paper>
        <Paper
          elevation={0}
          sx={{
            mt: 2,
            ...style.tableContainer,
          }}
        >
          <Grid
            hasSelection={false}
            hasPagination
            rows={entries}
            totalRows={entriesCount}
            pageNumber={pageNumber}
            pageSize={pageSize}
            columns={columnConfig}
            isLoading={isLoading}
            onPageNumberChange={handlePageNumberChange}
            onPageSizeChange={handlePageSizeChange}
            classes={{
              container: style.tableContainer,
            }}
            entriesText="Roles"
            onSortChange={handleSortChange}
            onReady={handleGridReady}
            order={order}
            orderBy={orderBy}
          />
        </Paper>
      </Box>
    </>
  );
};

export default UsersView;
